/*
 * Outings a guest weighs against each other (owner, 2026-10-28, idea 27 in the
 * suggestions lab). Under a quad ride, the city-wide fallback offered a
 * transfer to Essaouira, a private driver and two workshops: nothing a quad
 * rider wants next. Rides sit with rides, water with water, hands-on classes
 * with each other, a spa with a pool day.
 */
export const FAMILY_BY_CATEGORY: Record<string, string> = {
  quad: "ride",
  buggy: "ride",
  camel: "ride",
  horse: "ride",
  air: "ride",
  excursions: "ride",
  camp: "ride",
  "jet-ski": "water",
  boats: "water",
  diving: "water",
  pottery: "make",
  crafts: "make",
  weaving: "make",
  zellige: "make",
  "calligraphy-painting": "make",
  "cooking-class": "make",
  spas: "unwind",
  pools: "unwind",
  "day-trips": "away",
  trips: "away",
  "city-tour": "away",
};

/** Transfers and drivers are kept off every list (owner rule), here too. */
const NEVER_SUGGESTED = new Set(["transport"]);

type Categorised = { category?: { slug?: string | null } | null };

/**
 * The rows with transfers taken out and the closest outings first: same
 * family before the rest, the API's own order kept inside each group. Used by
 * the website's "You might also like" rail and the app's.
 */
export function relatedFirst<T extends Categorised>(rows: readonly T[], currentCategory: string | null): T[] {
  const kept = rows.filter((r) => !NEVER_SUGGESTED.has(r.category?.slug ?? ""));
  const family = currentCategory ? FAMILY_BY_CATEGORY[currentCategory] : undefined;
  if (!family) return kept;
  const near = kept.filter((r) => FAMILY_BY_CATEGORY[r.category?.slug ?? ""] === family);
  const rest = kept.filter((r) => FAMILY_BY_CATEGORY[r.category?.slug ?? ""] !== family);
  return [...near, ...rest];
}
